<template>
  <v-container fluid class="fluid theme_background borderRadius">
    <div v-if="loading">
      <v-row>
        <v-col cols="12" class="d-flex justify-center align-center">
          <v-progress-circular indeterminate></v-progress-circular>
        </v-col>
      </v-row>
    </div>
    <div v-else-if="noData">
      <v-row>
        <v-col cols="12" class="panelDataRow">
          <p class="right_panel_title">
            {{ $t('messages.info.noDataToDisplay') }}
          </p>
        </v-col>
      </v-row>
    </div>
    <div v-else>
      <v-row>
        <v-col cols="12" class="px-0">
          <p class="ml-2 right_panel_title">
            <v-avatar color="rgb(var(--v-theme-dark-color))" size="small" class="pa-0 mr-2">
              <v-icon color="rgb(var(--v-theme-lighten))" large>mdi-home-account</v-icon>
            </v-avatar>
            {{ $t('views.risk.population') }}
          </p>
        </v-col>
      </v-row>
      <template v-if="populationData.length !== 0">
        <v-row v-for="(entry, index) in populationData" :key="entry.id ?? index" class="panelDataRow">
          <square-chip
            :title="$t(`domain.enums.populationType.${entry.measurementType.name}`)"
            :color="entry.measurementType.color ?? ''"
            :subtitle="$t('domain.fields.buffer')"></square-chip>
          <square-chip :title="entry.value" color="rgb(var(--v-theme-surface))" :subtitle="$t('views.risk.population')"></square-chip>
        </v-row>
      </template>
    </div>
  </v-container>
</template>

<script lang="ts" setup>
import { ref, watch } from 'vue'

import { storeToRefs } from 'pinia'

import SquareChip from '@/components/Cards/SquareChip.vue'
import IncidentStore from '@/stores/incidentStore'
import type { Measurements } from '@/types/Incident'

const incidentStore = IncidentStore()
const { population } = storeToRefs(incidentStore)

const loading = ref(false)
const noData = ref(false)

const populationData = ref([] as Measurements[])

watch(
  population,
  (value) => {
    loading.value = true
    populationData.value = []

    if (value === undefined) {
      noData.value = false
    } else if (value.length == 0) {
      noData.value = true
      loading.value = false
    } else {
      noData.value = false
      populationData.value = value
      loading.value = false
    }
  },
  {
    immediate: true
  }
)
</script>

<style></style>
